"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DrawAction = exports.PromotionType = exports.DrawPrizeType = exports.DrawFrequencyMode = exports.State = exports.DrawClassification = exports.DrawType = exports.RESET_ENTRIES = exports.RESET_DRAW = exports.COUNT_FREE_ENTRY = exports.CLAIM_FREE_ENTRY_FOR_GUEST = exports.CLAIM_FREE_ENTRY = exports.FETCH_DETAILS_PAGE_PROGRESSIVE_PRIZES = exports.FETCH_PROGRESSIVE_PRIZES = exports.FETCH_HOME_PAGE_PROGRESSIVE_PRIZES = exports.FETCH_HOME_PAGE_PROMOTIONS = exports.FETCH_HOME_PAGE_PROGRESSIVE_PROMOTIONS = exports.OPT_OUT_SUBMIT = exports.OPT_OUT_FETCH_PREFERENCES = exports.RESET_PROMOTION = exports.SELECT_PROMOTION = exports.FETCH_DRAWS_BY_PROMOTION = exports.FETCH_PROMOTION_DETAILS = exports.FETCH_PROMOTIONS = exports.LOAD_MORE = exports.DOWNLOAD_DRAW_FILE = exports.FETCH_SWEEPSTAKE_DRAWS = exports.FETCH_DRAW_ENTRY_DETAILS = exports.FETCH_DRAW_WITH_ADDITIONAL_INFORMATION = exports.FETCH_LATEST_DRAW_HISTORY = exports.FETCH_ELIGIBLE_GAMES = exports.FETCH_DRAW_PRIZES_WITH_WINNERS = exports.FETCH_DRAW_PRIZES_WITH_CONTENT = exports.SELECT_DRAW = exports.FETCH_DRAW_PRIZES = exports.FETCH_DRAWS = void 0;
var DrawType;
(function (DrawType) {
    DrawType["PROMOTIONAL"] = "Promotional";
    DrawType["TOP_PRIZE"] = "Top Prize";
    DrawType["RECURRING"] = "Recurring";
    DrawType["OTHER"] = "Other";
})(DrawType || (DrawType = {}));
exports.DrawType = DrawType;
var DrawClassification;
(function (DrawClassification) {
    DrawClassification["SWEEPSTAKES"] = "SWEEPSTAKES";
    DrawClassification["SECOND_CHANCE"] = "SECOND_CHANCE";
    DrawClassification["OTHER"] = "OTHER";
})(DrawClassification || (DrawClassification = {}));
exports.DrawClassification = DrawClassification;
var DrawPrizeType;
(function (DrawPrizeType) {
    DrawPrizeType["CASH"] = "CASH";
    DrawPrizeType["EXPERIENCE"] = "EXPERIENCE";
    DrawPrizeType["MERCHANDISE"] = "MERCHANDISE";
    DrawPrizeType["OTHER"] = "OTHER";
})(DrawPrizeType || (DrawPrizeType = {}));
exports.DrawPrizeType = DrawPrizeType;
var PromotionType;
(function (PromotionType) {
    PromotionType["SWEEPSTAKES"] = "SWEEPSTAKES";
    PromotionType["SECOND_CHANCE"] = "SECOND_CHANCE";
    PromotionType["PROGRESSIVE"] = "PROGRESSIVE";
    PromotionType["OTHER"] = "OTHER";
})(PromotionType || (PromotionType = {}));
exports.PromotionType = PromotionType;
var DrawFrequencyMode;
(function (DrawFrequencyMode) {
    DrawFrequencyMode[DrawFrequencyMode["NON_RECURRING"] = 0] = "NON_RECURRING";
    DrawFrequencyMode[DrawFrequencyMode["RECURRING_DAILY"] = 1] = "RECURRING_DAILY";
    DrawFrequencyMode[DrawFrequencyMode["RECURRING_WEEKLY"] = 2] = "RECURRING_WEEKLY";
    DrawFrequencyMode[DrawFrequencyMode["RECURRING_MONTHLY"] = 3] = "RECURRING_MONTHLY";
    DrawFrequencyMode[DrawFrequencyMode["RECURRING_QUARTERLY"] = 4] = "RECURRING_QUARTERLY";
    DrawFrequencyMode[DrawFrequencyMode["RECURRING_CUSTOM"] = 5] = "RECURRING_CUSTOM";
})(DrawFrequencyMode || (DrawFrequencyMode = {}));
exports.DrawFrequencyMode = DrawFrequencyMode;
var State;
(function (State) {
    State[State["DELETED"] = 0] = "DELETED";
    State[State["PUBLISHED"] = 1] = "PUBLISHED";
    State[State["DRAFT"] = 2] = "DRAFT";
})(State || (State = {}));
exports.State = State;
var DrawStatus;
(function (DrawStatus) {
    DrawStatus[DrawStatus["ENDED"] = 0] = "ENDED";
    DrawStatus[DrawStatus["NOT_STARTED"] = 1] = "NOT_STARTED";
    DrawStatus[DrawStatus["ACTIVE"] = 2] = "ACTIVE";
})(DrawStatus || (DrawStatus = {}));
var DrawAction;
(function (DrawAction) {
    DrawAction["OPT_IN"] = "OPT_IN";
    DrawAction["OPT_OUT"] = "OPT_OUT";
})(DrawAction || (DrawAction = {}));
exports.DrawAction = DrawAction;
var FETCH_DRAWS = 'draws/FETCH';
exports.FETCH_DRAWS = FETCH_DRAWS;
var SELECT_DRAW = 'draws/SELECT_DRAW';
exports.SELECT_DRAW = SELECT_DRAW;
var FETCH_DRAW_PRIZES = 'draws/FETCH_DRAW_PRIZES';
exports.FETCH_DRAW_PRIZES = FETCH_DRAW_PRIZES;
var FETCH_DRAW_PRIZES_WITH_CONTENT = 'draws/FETCH_DRAW_PRIZES_WITH_CONTENT';
exports.FETCH_DRAW_PRIZES_WITH_CONTENT = FETCH_DRAW_PRIZES_WITH_CONTENT;
var FETCH_DRAW_WITH_ADDITIONAL_INFORMATION = 'draws/FETCH_DRAW_WITH_ADDITIONAL_INFORMATION';
exports.FETCH_DRAW_WITH_ADDITIONAL_INFORMATION = FETCH_DRAW_WITH_ADDITIONAL_INFORMATION;
var FETCH_DRAW_PRIZES_WITH_WINNERS = 'draws/FETCH_DRAW_PRIZES_WITH_WINNERS';
exports.FETCH_DRAW_PRIZES_WITH_WINNERS = FETCH_DRAW_PRIZES_WITH_WINNERS;
var FETCH_LATEST_DRAW_HISTORY = 'draws/FETCH_LATEST_DRAW_HISTORY';
exports.FETCH_LATEST_DRAW_HISTORY = FETCH_LATEST_DRAW_HISTORY;
var FETCH_ELIGIBLE_GAMES = 'draws/FETCH_ELIGIBLE_GAMES';
exports.FETCH_ELIGIBLE_GAMES = FETCH_ELIGIBLE_GAMES;
var FETCH_DRAW_ENTRY_DETAILS = 'draws/FETCH_DRAW_ENTRY_DETAILS';
exports.FETCH_DRAW_ENTRY_DETAILS = FETCH_DRAW_ENTRY_DETAILS;
var LOAD_MORE = 'draws/LOAD_MORE';
exports.LOAD_MORE = LOAD_MORE;
var DOWNLOAD_DRAW_FILE = 'draws/DOWNLOAD_DRAW_FILE';
exports.DOWNLOAD_DRAW_FILE = DOWNLOAD_DRAW_FILE;
var FETCH_SWEEPSTAKE_DRAWS = 'draws/FETCH_SWEEPSTAKE_DRAWS';
exports.FETCH_SWEEPSTAKE_DRAWS = FETCH_SWEEPSTAKE_DRAWS;
var FETCH_PROMOTIONS = 'draws/FETCH_PROMOTIONS';
exports.FETCH_PROMOTIONS = FETCH_PROMOTIONS;
var FETCH_PROMOTION_DETAILS = 'draws/FETCH_PROMOTION_DETAILS';
exports.FETCH_PROMOTION_DETAILS = FETCH_PROMOTION_DETAILS;
var FETCH_DRAWS_BY_PROMOTION = 'draws/FETCH_DRAWS_BY_PROMOTION';
exports.FETCH_DRAWS_BY_PROMOTION = FETCH_DRAWS_BY_PROMOTION;
var SELECT_PROMOTION = 'draws/SELECT_PROMOTION';
exports.SELECT_PROMOTION = SELECT_PROMOTION;
var RESET_PROMOTION = 'draws/RESET_PROMOTION';
exports.RESET_PROMOTION = RESET_PROMOTION;
var OPT_OUT_FETCH_PREFERENCES = 'draws/OPT_OUT_FETCH_PREFERENCES';
exports.OPT_OUT_FETCH_PREFERENCES = OPT_OUT_FETCH_PREFERENCES;
var OPT_OUT_SUBMIT = 'draws/OPT_OUT_SUBMIT';
exports.OPT_OUT_SUBMIT = OPT_OUT_SUBMIT;
var FETCH_HOME_PAGE_PROMOTIONS = 'draws/FETCH_HOME_PAGE_PROMOTIONS';
exports.FETCH_HOME_PAGE_PROMOTIONS = FETCH_HOME_PAGE_PROMOTIONS;
var FETCH_HOME_PAGE_PROGRESSIVE_PROMOTIONS = 'draws/FETCH_HOME_PAGE_PROGRESSIVE_PROMOTIONS';
exports.FETCH_HOME_PAGE_PROGRESSIVE_PROMOTIONS = FETCH_HOME_PAGE_PROGRESSIVE_PROMOTIONS;
var FETCH_HOME_PAGE_PROGRESSIVE_PRIZES = 'draws/FETCH_HOME_PAGE_PROGRESSIVE_PRIZES';
exports.FETCH_HOME_PAGE_PROGRESSIVE_PRIZES = FETCH_HOME_PAGE_PROGRESSIVE_PRIZES;
var FETCH_PROGRESSIVE_PRIZES = 'draws/FETCH_PROGRESSIVE_PRIZES';
exports.FETCH_PROGRESSIVE_PRIZES = FETCH_PROGRESSIVE_PRIZES;
var FETCH_DETAILS_PAGE_PROGRESSIVE_PRIZES = 'draws/FETCH_DETAILS_PAGE_PROGRESSIVE_PRIZES';
exports.FETCH_DETAILS_PAGE_PROGRESSIVE_PRIZES = FETCH_DETAILS_PAGE_PROGRESSIVE_PRIZES;
var CLAIM_FREE_ENTRY_FOR_GUEST = 'draws/CLAIM_FREE_ENTRY_FOR_GUEST';
exports.CLAIM_FREE_ENTRY_FOR_GUEST = CLAIM_FREE_ENTRY_FOR_GUEST;
var CLAIM_FREE_ENTRY = 'draws/CLAIM_FREE_ENTRY';
exports.CLAIM_FREE_ENTRY = CLAIM_FREE_ENTRY;
var COUNT_FREE_ENTRY = 'draws/COUNT_FREE_ENTRY';
exports.COUNT_FREE_ENTRY = COUNT_FREE_ENTRY;
var RESET_DRAW = 'draws/RESET_DRAW';
exports.RESET_DRAW = RESET_DRAW;
var RESET_ENTRIES = 'draws/RESET_ENTRIES';
exports.RESET_ENTRIES = RESET_ENTRIES;
//# sourceMappingURL=types.js.map